import { render, staticRenderFns } from "./MsinEdit.vue?vue&type=template&id=fb0bb7ba&scoped=true&"
import script from "./MsinEdit.vue?vue&type=script&lang=js&"
export * from "./MsinEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0bb7ba",
  null
  
)

export default component.exports